function toTeamworkDate(date) {
  let d = new Date(date);
  let year = d.getFullYear();
  let month =
    d.getMonth() + 1 <= 9 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1;
  let day = d.getDate() <= 9 ? "0" + d.getDate() : d.getDate();
  return `${year}${month}${day}`;
}

module.exports = toTeamworkDate;



//////////////////
// WEBPACK FOOTER
// ./utils/toTeamworkDate.js
// module id = 3868
// module chunks = 0